import { CSSProperties, MouseEventHandler, PropsWithChildren, ReactNode } from 'react';

import { IconClose } from '@aicon-dev/caas-ui';

import { Mask } from '../Mask';

import { Menu } from './Menu';
import {
  divider,
  sheet,
  sheetCloseButton,
  sheetContent,
  sheetHeader,
  sheetTitle,
} from './styles.css';

export interface SheetProps {
  visible?: boolean;
  title?: ReactNode;
  children: ReactNode;
  onClose?: MouseEventHandler<HTMLButtonElement>;
}

export const Sheet = (props: SheetProps) => {
  const { visible, title, children, onClose } = props;

  return (
    <Mask visible={visible} onMaskClick={onClose}>
      <div className={sheet}>
        {(!!title || !!onClose) && (
          <div className={sheetHeader}>
            <div className={sheetTitle}>{title}</div>
            {onClose && (
              <button className={sheetCloseButton} onClick={onClose}>
                <IconClose />
              </button>
            )}
          </div>
        )}
        <div>{children}</div>
      </div>
    </Mask>
  );
};

Sheet.Menu = Menu;
Sheet.Divider = () => {
  return <div className={divider} />;
};
Sheet.Content = (props: PropsWithChildren<{ style?: CSSProperties }>) => {
  const { children, ...args } = props;
  return (
    <div className={sheetContent} {...args}>
      {children}
    </div>
  );
};
